// offline-detector.js
// Utility to detect if running in offline/Electron mode

export const isOfflineMode = () => {
  // Check if running in Electron
  return window && window.electron !== undefined;
};

export const getApiBaseUrl = () => {
  if (isOfflineMode()) {
    return 'http://localhost:8080';
  }
  return 'http://localhost:9090';
  // return 'https://api.sns.aaibuzz.com';
};

export const setupOfflineMode = (store) => {
  if (isOfflineMode()) {
    console.log('Running in offline mode - using SQLite database');
    store.dispatch('settings/setOfflineMode', true);

    // Verify SQLite database connectivity
    if (window.electron && window.electron.query) {
      window.electron.query('SELECT 1', [])
        .then(() => {
          console.log('SQLite database is accessible');
        })
        .catch(error => {
          console.error('Could not access SQLite database:', error);
          alert('Warning: SQLite database is not accessible. The app may not work properly offline.');
        });
    } else {
      console.warn('Electron database query interface not available');
    }
  }
};